export default "skymp5-front/166b1ce633ed5277d4fc660842a00fc5.gif";